import React from "react";
import useWindowSize from "../../../hook/windowSize"; // Import the custom hook
import "./SkeletonLoader.css";

const Skeleton = () => {
  const windowWidth = useWindowSize(); // Get the current window width

  // Determine the number of skeleton cards based on screen size
  const numberOfCards =
    windowWidth < 450
      ? 1
      : windowWidth < 601
      ? 2
      : windowWidth < 1024
      ? 3
      : windowWidth < 1143
      ? 3
      : windowWidth < 1344
      ? 4
      : windowWidth < 1560
      ? 5
      : windowWidth < 1776
      ? 6
      : windowWidth < 1992
      ? 7
      : 8; // Mobile: 4, Tablet: 6, Desktop: 8

  return (
    <div className="skeleton-loader">
      {[...Array(numberOfCards)].map((_, index) => (
        <div key={index} className="skeleton-card">
          <div className="skeleton-thumbnail"></div>
          <div className="skeleton-text"></div>
        </div>
      ))}
    </div>
  );
};

export default Skeleton;
